export default __webpack_public_path__ + "media/components/AudienceEdit/formats-6c84647d765cc80f311511f72f6bf6a0.png";